import { createAction, createSlice } from '@reduxjs/toolkit';
import { CoreMsgTypes, PCGUser } from '@tassat/payments-definitions';

export interface PCGUserState {
    [key: string]: PCGUser;
}

const initialState: PCGUserState = {};

const initialLoad = createAction<{ pcgUsers: PCGUserState }>('InitialLoad');
const pcgUserRecord = createAction<PCGUser>(CoreMsgTypes.PCGUser);

const pcgUsersSlice = createSlice({
    name: 'pcgUsers',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initialLoad, (_state, action) => {
                return action.payload.pcgUsers;
            })
            .addCase(pcgUserRecord, (state, action) => {
                if (action.payload.IsDeleted) {
                    delete state[action.payload.PCGUserId];
                } else {
                    state[action.payload.PCGUserId] = action.payload;
                }
            })
            .addDefaultCase(state => state);
    }
});

export default pcgUsersSlice.reducer;